import { reportTypeApi } from "../../api";

const ReportTypeService = {
  fetchDropdown: async () => {
    const response = await reportTypeApi.fetchCustom('/dropdown');
    return response.data;
  },
};

export default ReportTypeService;
